/* eslint max-len: 0*/
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { Link } from 'react-router';
import Identity from './Identity';

const CreditCheckConsentTemplate = ({
  company,
  customerID,
  customerName,
  jobTitle,
  identity,
  identityTypeID,
}) => (
  <div className="consent-box">
    <p><b>{moment().format('DD MMM YYYY')}</b></p>
    <div className="detail">
      <div>
        <h5>
          <b>{company.name}</b>
        </h5>
        <p>
          {company.address1}, {company.postcode}, {company.state}, {company.country}
        </p>
      </div>
    </div>
    <br />
    <p>
      Dear Sir/Madam,
    </p>
    <h4>
      RE: Consent Authorisation
    </h4>
    <p>
      Pursuant to the CRA Act and Central Bank of Malaysia Act, I/we the undersigned do hereby give my/our consent to you, TRB Ventures Sdn Bhd (MHub) and CTOS Data Systems Sdn Bhd (“CTOS”), a registered credit reporting agency under the CRA Act to process my/our company and personal data.
    </p>
    <p>
      By this consent, I/We understand and agree that:
    </p>
    <div>
      <ol>
        <li>
          You may conduct credit/trade check, CCRIS and DCHEQUE checks on us and where applicable with CTOS at any time for as long as I/we have a trade relationship with you or where any dues remain unpaid and outstanding with you, for any one or more of the following purposes:
          <ul>
            <li>
              - Opening of account
            </li>
            <li>
              - Legal documentation consequent to a contract or facility granted by you
            </li>
            <li>
              - Credit/Account monitoring
            </li>
            <li>
              - Credit/Account evaluation
            </li>
            <li>
              - Credit/Account review
            </li>
            <li>
              - Debt recovery
            </li>
          </ul>
        </li>
        <li>
          You may disclose any information on the Parties’ conduct of their accounts with you, to any business entity/ies for bona fide trade checking at any time. The Parties are also aware and understand that such information will be provided to a credit reporting agency/ies, who may in turn share such information to subscribers of their service.
        </li>
        <li>
          Where you require any processing of our application to be processed by any processing centre located outside Malaysia (including your Head Office), the Parties hereby give consent to CTOS to disclose their credit, CCRIS & DCHEQUE reports to such locations outside Malaysia.
        </li>
        <li>
          Apart from the above, the Parties undersigned do give our consent to you and the CTOS, to process my/our personal data as per the PDPA Act.
        </li>
      </ol>
      <br />
      <p><b>
        {customerName} <br />
        <Identity type={identityTypeID} identity={identity} /> <br />
        {jobTitle !== '' ? jobTitle : <Link to={`/customers/${customerID}/`} target="_blank">Add Job Title</Link>}
      </b></p>
      <Link to={`/customers/${customerID}/`} target="_blank">Edit</Link>
    </div>
  </div>
);

CreditCheckConsentTemplate.propTypes = {
  company: PropTypes.shape({
    name: PropTypes.string,
    address1: PropTypes.string,
    postcode: PropTypes.string,
    state: PropTypes.string,
    country: PropTypes.string,
  }).isRequired,
  jobTitle: PropTypes.string.isRequired,
  customerName: PropTypes.string.isRequired,
  identity: PropTypes.string.isRequired,
  identityTypeID: PropTypes.number.isRequired,
  customerID: PropTypes.string.isRequired,
};

CreditCheckConsentTemplate.defaultProps = {
};

export default CreditCheckConsentTemplate;



// WEBPACK FOOTER //
// ./src/components/CreditCheckConsentTemplate.jsx